import { createSliceSelectors } from '../utils'

const RegistrationSelectors = createSliceSelectors('registration', ['registrationPageContext'])

export default RegistrationSelectors
